// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__1GDKg","qmeta":"Video_qmeta__37HKl"};